import { render, staticRenderFns } from "./SharedProductForm.template.vue?vue&type=template&id=368c38e5&scoped=true&"
var script = {}
import style0 from "./SharedProductForm.template.vue?vue&type=style&index=0&id=368c38e5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368c38e5",
  null
  
)

export default component.exports